import { formatRupiah } from "@/components/property/roomMeta";

export { formatRupiah };

export const BOOKING_STATUS_LABELS = {
  pending: "Menunggu",
  approved: "Disetujui",
  rejected: "Ditolak",
  cancelled: "Dibatalkan",
  completed: "Selesai",
};

export const BOOKING_STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  approved: "bg-emerald-100 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
  cancelled: "bg-muted text-muted-foreground border-border",
  completed: "bg-sky-100 text-sky-700 border-sky-200",
};

export const DURATION_UNIT_LABELS = { day: "Hari", month: "Bulan", year: "Tahun" };
export const DURATION_UNIT_PRICE_KEY = { day: "price_daily", month: "price_monthly", year: "price_yearly" };

// --- Property survey / visit schedule ---
export const SURVEY_STATUS_LABELS = {
  pending: "Menunggu Konfirmasi",
  confirmed: "Dikonfirmasi",
  cancelled: "Dibatalkan",
  completed: "Selesai",
};
export const SURVEY_STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  confirmed: "bg-emerald-100 text-emerald-700 border-emerald-200",
  cancelled: "bg-muted text-muted-foreground border-border",
  completed: "bg-sky-100 text-sky-700 border-sky-200",
};

export const PAYMENT_STATUS_LABELS = {
  pending: "Menunggu Pembayaran",
  paid: "Pembayaran Berhasil",
  failed: "Pembayaran Gagal",
  expired: "Pembayaran Kedaluwarsa",
  cancelled: "Pembayaran Dibatalkan",
};

export const PAYMENT_STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  failed: "bg-rose-100 text-rose-700 border-rose-200",
  expired: "bg-orange-100 text-orange-700 border-orange-200",
  cancelled: "bg-muted text-muted-foreground border-border",
};

export const BOOKING_STATUS_FILTERS = [
  { value: "all", label: "Semua" },
  { value: "pending", label: "Menunggu" },
  { value: "approved", label: "Disetujui" },
  { value: "rejected", label: "Ditolak" },
  { value: "cancelled", label: "Dibatalkan" },
  { value: "completed", label: "Selesai" },
];

// --- Payment accounting (Step 14+): room price vs deposit tracked separately ---
export const ROOM_PAY_LABELS = {
  unpaid: "Belum Dibayar",
  partial: "Belum Lunas",
  fully_paid: "LUNAS",
};
export const DEPOSIT_PAY_LABELS = {
  not_required: "Tidak Ada",
  unpaid: "Belum Dibayar",
  partial: "Belum Lunas",
  fully_paid: "LUNAS",
};
export const BOOKING_PAY_LABELS = {
  partial: "Partial",
  room_fully_paid: "Menunggu Pelunasan Deposit",
  fully_paid: "Fully Paid",
};
export const PAY_STATUS_STYLES = {
  not_required: "bg-muted text-muted-foreground border-border",
  unpaid: "bg-muted text-muted-foreground border-border",
  partial: "bg-amber-100 text-amber-700 border-amber-200",
  room_fully_paid: "bg-sky-100 text-sky-700 border-sky-200",
  fully_paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

// --- Cancellation refund (Step 20) ---
export const REFUND_STATUS_LABELS = {
  none: "Tanpa Refund",
  pending: "Menunggu Persetujuan",
  approved: "Disetujui — Menunggu Proses Duitku",
  rejected: "Ditolak",
  processed: "Refund Berhasil",
  failed: "Gagal Diproses",
};
export const REFUND_STATUS_STYLES = {
  none: "bg-muted text-muted-foreground border-border",
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  approved: "bg-sky-100 text-sky-700 border-sky-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
  processed: "bg-emerald-100 text-emerald-700 border-emerald-200",
  failed: "bg-rose-100 text-rose-700 border-rose-200",
};
export const REFUND_TYPE_LABELS = {
  full: "Full Refund",
  partial: "Partial Refund",
  non_refundable: "Non-Refundable",
};
export function policyLineText(type, rate) {
  if (type === "full") return "Full Refund (100%)";
  if (type === "non_refundable") return "Non-Refundable (0%)";
  return `Partial Refund (${rate}%)`;
}

export function formatDate(iso) {  if (!iso) return "-";
  const s = iso.length === 10 ? iso + "T00:00:00" : iso;
  const d = new Date(s);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
}

export function addPeriod(dateStr, duration, unit) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  const n = Number(duration) || 0;
  if (unit === "day") d.setDate(d.getDate() + n);
  else if (unit === "month") d.setMonth(d.getMonth() + n);
  else if (unit === "year") d.setFullYear(d.getFullYear() + n);
  return d.toISOString().slice(0, 10);
}
